// Global Clear Input Icons Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Function to create clear icon for an input field
  function addClearIconToInput(inputElement) {
    // Skip if already has clear icon or is a select/textarea
    if (inputElement.classList.contains('has-clear-icon') || 
        inputElement.tagName === 'SELECT' || 
        inputElement.tagName === 'TEXTAREA' ||
        inputElement.type === 'password') {
      return;
    }

    // Add wrapper if not already wrapped
    let wrapper = inputElement.parentElement;
    if (!wrapper.classList.contains('form-input-wrapper')) {
      wrapper = document.createElement('div');
      wrapper.className = 'form-input-wrapper';
      inputElement.parentNode.insertBefore(wrapper, inputElement);
      wrapper.appendChild(inputElement);
    }

    // Add clear icon class to input
    inputElement.classList.add('has-clear-icon');

    // Create clear icon
    const clearIcon = document.createElement('div');
    clearIcon.className = 'form-clear-icon';
    clearIcon.innerHTML = `
      <svg aria-hidden="true" focusable="false" class="icon icon-close" viewBox="0 0 18 17">
        <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
      </svg>
    `;

    // Add clear icon to wrapper
    wrapper.appendChild(clearIcon);

    // Function to toggle clear icon visibility
    function toggleClearIcon() {
      if (inputElement.value.trim() !== '') {
        clearIcon.classList.add('show');
      } else {
        clearIcon.classList.remove('show');
      }
    }

    // Function to clear input and hide icon
    function clearInput() {
      inputElement.value = '';
      clearIcon.classList.remove('show');
      inputElement.focus();
      
      // Trigger input event to update any dependent functionality
      inputElement.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // Add event listeners
    inputElement.addEventListener('input', toggleClearIcon);
    
    // Hide clear icon when input loses focus
    inputElement.addEventListener('blur', function() {
      clearIcon.classList.remove('show');
    });

    // Show clear icon when input gains focus (if there's content)
    inputElement.addEventListener('focus', function() {
      toggleClearIcon();
    });
    
    clearIcon.addEventListener('click', function(e) {
      e.preventDefault();
      clearInput();
    });

    // Initial state
    toggleClearIcon();
  }

  // Function to remove clear icons from textareas (cleanup)
  function removeClearIconsFromTextareas() {
    const textareas = document.querySelectorAll('textarea.form_input, textarea.has-clear-icon');
    textareas.forEach(function(textarea) {
      // Remove the has-clear-icon class
      textarea.classList.remove('has-clear-icon');
      
      // Find and remove any clear icons within the textarea's parent wrapper
      const wrapper = textarea.parentElement;
      if (wrapper && wrapper.classList.contains('form-input-wrapper')) {
        const clearIcon = wrapper.querySelector('.form-clear-icon');
        if (clearIcon) {
          clearIcon.remove();
        }
      }
    });
  }

  // Function to initialize clear icons for all form inputs
  function initializeClearIcons() {
    // First, remove any existing clear icons from textareas
    removeClearIconsFromTextareas();
    
    // Find all form input fields
    const formInputs = document.querySelectorAll('.form_input.w-input, .form_input');
    
    formInputs.forEach(function(input) {
      // Only add to text, email, search, tel, url inputs (exclude textareas)
      const allowedTypes = ['text', 'email', 'search', 'tel', 'url'];
      if (allowedTypes.includes(input.type)) {
        addClearIconToInput(input);
      }
    });
  }

  // Initialize on page load
  initializeClearIcons();

  // Re-initialize when new content is loaded (for dynamic forms)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Remove clear icons from any new textareas
            removeClearIconsFromTextareas();
            
            const newInputs = node.querySelectorAll ? node.querySelectorAll('.form_input.w-input, .form_input') : [];
            newInputs.forEach(function(input) {
              const allowedTypes = ['text', 'email', 'search', 'tel', 'url'];
              if (allowedTypes.includes(input.type)) {
                addClearIconToInput(input);
              }
            });
          }
        });
      }
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
